module.exports = __webpack_public_path__ + "static/media/appictus-nav.dfb24247.png";